import React from "react";
import { useRoleModel } from "../roleModel";
import { SearchTypeEnum } from "@components/YhPageHeader/Types";
import { YhPageHeader } from "@components/YhPageHeader";
import { StatusDs } from "@src/types/FmsDs";


export function PageHeader() {
    const {
        searchParam,
        onReset,
        onSearch,
        loadData,
        updateSearchParam,
        roleDs,
    } = useRoleModel();

    const searchFields = [

        {
            type: SearchTypeEnum.Select,
            xxl: 4,
            span: 4,
            placeholder: "角色名称",
            fieldName: "code",
            size: "small",
            disabled: false,
            options: roleDs
        },
        {
            type: SearchTypeEnum.Select,
            xxl: 4,
            span: 4,
            placeholder: "角色状态",
            fieldName: "status",
            size: "small",
            disabled: false,
            options: StatusDs
        },

    ]

    return (
        <YhPageHeader
            title="角色管理"
            searchValues={searchParam}
            searchFields={searchFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={onReset}
        />
    );
}